import { ListItemButton, Stack, SxProps } from "@mui/material";
import Text from "src/components/Displays/Text";
import { ChevronRight2 } from "src/assets";

interface OemListItemProps {
  sx?: SxProps;
  itemText: string;
  handleItemClick: () => {};
}

const OemListItem = ({ itemText, handleItemClick, sx }: OemListItemProps) => {
  return (
    <>
      <ListItemButton onClick={handleItemClick} sx={sx}>
        <Stack
          sx={{
            justifyContent: "space-between",
            flexDirection: "row",
            alignItems: "center",
            width: "100%",
            py: 2,
          }}
        >
          <Text
            text={itemText}
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: theme.palette.black[50],
            })}
          />
          <Stack alignItems={"end"}>
            <ChevronRight2 />
          </Stack>
        </Stack>
      </ListItemButton>
    </>
  );
};

export default OemListItem;
